// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1614":"fc63846b47381507","3327":"093d733c6013b97f"}[chunkId] + ".js";
};